import { render, staticRenderFns } from "./FilterManagement.vue?vue&type=template&id=53da90ff&"
import script from "./FilterManagement.vue?vue&type=script&lang=js&"
export * from "./FilterManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FilterManagement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53da90ff')) {
      api.createRecord('53da90ff', component.options)
    } else {
      api.reload('53da90ff', component.options)
    }
    module.hot.accept("./FilterManagement.vue?vue&type=template&id=53da90ff&", function () {
      api.rerender('53da90ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FilterManagement.vue"
export default component.exports